import React from 'react';
import { Card } from 'reactstrap';
import { userData } from '../../util/userData';
import { redirectToUrl } from '../UserAdministrationContainer/lib/utils';
import { IOverviewCodesPhpResponse } from './index';

interface IFeedbackTopicsContainerProps {
  overviewCodes: IOverviewCodesPhpResponse
}

function comments(name: string) {
  const f = userData.getFilters();
  f.commentType = name;
  userData.updateFilters(f);
  redirectToUrl('commentdetails')
}

export function FeedbackTopicsContainer(props: IFeedbackTopicsContainerProps) {
  const {
    sugg,
    neut,
    comp,
    periodLabel,
    surveyLabel,
    avidLabel,
    segmentCategory,
    segment,
    customerName
  } = props.overviewCodes

  return (
    <Card id="FeedbackTopicsContainer" style={{ height: '400px' }}>
      <div className="card-content" style={{ padding: 0 }}>
        <span className="card-title" style={{ padding: 10 }}>
          {`${customerName} Feedback Topics (Most Frequent)`}
        </span>
        <span style={{ padding: 10 }}>
          <small>
            {avidLabel} |&nbsp;
            {surveyLabel} |&nbsp;
            {periodLabel} |&nbsp;
            {segmentCategory && <> {segmentCategory}</>}
            {segmentCategory && segment && <>:&nbsp;{segment}</>}
            {segment && <>&nbsp;|&nbsp;</>}
            All Measures
          </small>
        </span>
      </div>
      <div className="card-action">
        <table style={{ height: '298px' }}>
          <thead>
            <tr>
              <th>Sentiment</th>
              <th>Category</th>
            </tr>
          </thead>
          <tbody>
            {
              comp.map((category, index) => {
                return (
                  <tr key={index}>
                    <td style={{ textAlign: 'center' }}><img src="images/compliment_circle_24.png?v=3.1" /></td>
                    <td><a className="link" onClick={() => {
                      comments(category.name);
                    }}>{category.name}</a></td>
                  </tr>
                );
              })
            }
            {
              sugg.map((category, index) => {
                return (
                  <tr key={index}>
                    <td style={{ textAlign: 'center' }}><img src="images/suggestion_circle_24.png?v=3.1" /></td>
                    <td><a className="link" onClick={() => {
                      comments(category.name);
                    }}>{category.name}</a></td>
                  </tr>
                );
              })
            }
            {
              neut.map((category, index) => {
                return (
                  <tr key={index}>
                    <td style={{ textAlign: 'center' }}><img src="images/neutral_circle_24.png?v=3.1" /></td>
                    <td><a className="link" onClick={() => {
                      comments(category.name);
                    }}>{category.name}</a></td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    </Card>
  );
}
